module.exports = __webpack_public_path__ + "static/media/flv.1f8e1407.png";